<template>
    <label :for="id" class="text-sm text-[#2C2C2C] flex justify-start items-start">
        <input
            type="checkbox"
            class="me-2 checked:bg-checkbox bg-no-repeat bg-center !bg-[length:12px] -mt-1 border rounded-sm border-secondary text-primary focus:ring-0 bg-white !focus:ring-offset-0 relative top-[5px]"
            :class="{
                'hasErr': hasErr,
                'disabled': disabled
                }"
            :id="id"
            :value="checked"
            :disabled="disabled"
            v-model="model"
        />
        <slot></slot>
    </label>
</template>

<script>
export default {
	name: "default-checkbox",
	props: {
		id: String,
		name: String,
		value: [Number, String, Boolean],
		modelValue: Boolean,
        hasErr: Boolean,
        disabled: Boolean,
        checked: Boolean
	},
	computed: {
		model: {
			get() { return this.modelValue },
			set(newValue) { this.$emit('update:modelValue', newValue)}
		}
	}
}
</script>
<style scoped>
input:checked + svg {
    @apply !block
}
[type='checkbox']:not(:checked){
    border-color: #616161 ;
 }
[type='checkbox']:checked {
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
   backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
[type='checkbox']:focus {
    box-shadow: none;
}

[type='checkbox']:disabled {
    @apply grayscale bg-slate-400
}

</style>